"use client"
import { Phone, Mail, MapPin, User } from "lucide-react"

export default function RegionalManagers() {
  const managers = [
    {
      name: "John Smith",
      title: "Southeast Regional Manager",
      region: "Georgia, South Carolina, Florida",
      phone: "(404) 555-0201",
      email: "j.smith@company.com",
      office: "Atlanta, GA",
      experience: "15 years",
    },
    {
      name: "Sarah Johnson",
      title: "Alabama Regional Manager",
      region: "Alabama, Mississippi",
      phone: "(205) 555-0202",
      email: "s.johnson@company.com",
      office: "Birmingham, AL",
      experience: "12 years",
    },
    {
      name: "Mike Davis",
      title: "Tennessee Regional Manager",
      region: "Tennessee, Kentucky",
      phone: "(615) 555-0203",
      email: "m.davis@company.com",
      office: "Nashville, TN",
      experience: "18 years",
    },
    {
      name: "Lisa Wilson",
      title: "North Carolina Regional Manager",
      region: "North Carolina, Virginia",
      phone: "(704) 555-0204",
      email: "l.wilson@company.com",
      office: "Charlotte, NC",
      experience: "10 years",
    },
    {
      name: "David Brown",
      title: "Texas Regional Manager",
      region: "Texas, Oklahoma, Arkansas",
      phone: "(214) 555-0205",
      email: "d.brown@company.com",
      office: "Dallas, TX",
      experience: "14 years",
    },
    {
      name: "Jennifer Garcia",
      title: "Louisiana Regional Manager",
      region: "Louisiana, Mississippi Gulf Coast",
      phone: "(504) 555-0206",
      email: "j.garcia@company.com",
      office: "New Orleans, LA",
      experience: "11 years",
    },
  ]

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl lg:text-3xl font-bold text-[#004261] mb-2 uppercase tracking-wide">
            Regional Managers
          </h1>
          <div className="w-16 h-1 bg-[#00CCFE] mb-4"></div>
          <p className="text-gray-600">Contact information for regional management team</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {managers.map((manager, index) => (
            <div
              key={index}
              className={`rounded-lg shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow ${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              }`}
            >
              {/* Header */}
              <div className="bg-[#004261] px-6 py-4">
                <div className="flex items-center">
                  <div className="h-12 w-12 bg-[#00CCFE] rounded-full flex items-center justify-center mr-4">
                    <User className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg uppercase">{manager.name}</h3>
                    <p className="text-blue-200 text-sm uppercase font-medium">{manager.title}</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="space-y-4">
                  {/* Region */}
                  <div className="flex items-start">
                    <MapPin className="h-4 w-4 text-[#00CCFE] mr-3 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-xs font-medium text-[#004261] uppercase">Coverage Area</p>
                      <p className="text-sm text-gray-600">{manager.region}</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-center">
                    <Phone className="h-4 w-4 text-[#00CCFE] mr-3 flex-shrink-0" />
                    <div>
                      <p className="text-xs font-medium text-[#004261] uppercase">Phone</p>
                      <a
                        href={`tel:${manager.phone}`}
                        className="text-sm text-[#00CCFE] hover:text-[#004261] hover:underline font-medium transition-colors"
                      >
                        {manager.phone}
                      </a>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-center">
                    <Mail className="h-4 w-4 text-[#00CCFE] mr-3 flex-shrink-0" />
                    <div>
                      <p className="text-xs font-medium text-[#004261] uppercase">Email</p>
                      <a
                        href={`mailto:${manager.email}`}
                        className="text-sm text-[#00CCFE] hover:text-[#004261] hover:underline font-medium transition-colors break-all"
                      >
                        {manager.email}
                      </a>
                    </div>
                  </div>

                  {/* Office Location */}
                  <div className="flex items-center">
                    <div className="h-4 w-4 bg-[#00CCFE] rounded-full mr-3 flex-shrink-0"></div>
                    <div>
                      <p className="text-xs font-medium text-[#004261] uppercase">Office</p>
                      <p className="text-sm text-gray-600">{manager.office}</p>
                    </div>
                  </div>

                  {/* Experience */}
                  <div className="flex items-center">
                    <div className="h-4 w-4 bg-[#004261] rounded-full mr-3 flex-shrink-0"></div>
                    <div>
                      <p className="text-xs font-medium text-[#004261] uppercase">Experience</p>
                      <p className="text-sm text-gray-600">{manager.experience}</p>
                    </div>
                  </div>
                </div>

                {/* Contact Buttons */}
                <div className="mt-6 flex space-x-2">
                  <a
                    href={`tel:${manager.phone}`}
                    className="flex-1 bg-[#00CCFE] text-white text-center py-2 px-3 rounded text-sm font-medium hover:bg-[#004261] transition-colors"
                  >
                    Call
                  </a>
                  <a
                    href={`mailto:${manager.email}`}
                    className="flex-1 bg-[#004261] text-white text-center py-2 px-3 rounded text-sm font-medium hover:bg-[#00283b] transition-colors"
                  >
                    Email
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Information */}
        <div className="mt-8 bg-blue-50 border border-[#00CCFE] rounded-lg p-6">
          <h3 className="text-lg font-bold text-[#004261] mb-4 uppercase">Contact Guidelines</h3>
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <h4 className="font-medium text-[#004261] mb-2">Business Hours</h4>
              <p className="text-sm text-gray-600">Monday - Friday: 8:00 AM - 6:00 PM</p>
              <p className="text-sm text-gray-600">Saturday: 9:00 AM - 2:00 PM</p>
              <p className="text-sm text-gray-600">Sunday: Closed</p>
            </div>
            <div>
              <h4 className="font-medium text-[#004261] mb-2">Response Time</h4>
              <p className="text-sm text-gray-600">Phone calls: Within 2 hours</p>
              <p className="text-sm text-gray-600">Emails: Within 4 hours</p>
              <p className="text-sm text-gray-600">Urgent matters: Within 30 minutes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
